import { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

export const SocketProvider = ({ token, children }) => {
  const [socket, setSocket] = useState(null);

  // const socket = useMemo(() => {
  //   if (!token) return null;
  //   // env -> socket_url changed to be in .dev
  //   return io(process.env.REACT_APP_SOCKET_URL, {
  //     auth: { token },
  //     path: '/backoffice'
  //   });
  // }, [token]);

  useEffect(() => {
    if (!token) return null;
    // env -> socket_url changed to be in .dev
    const sock = io(process.env.REACT_APP_SOCKET_URL, {
      auth: { token },
      path: '/backoffice'
    });
    setSocket(sock);
  }, [token]);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};

export const useSocket = () => useContext(SocketContext);
